const laoding = [];
export default function reducer(state = laoding, action) {
  switch (action.type) {
    case "SET_LOADING":
      return action.data;
    case "PUSH_LOADING":
      return [...state].push();
    case "POP_LOADING":
      return [...state].pop();
    default:
      return state;
  }
}
